export default class CpfHelper {
  static maskCpfCnpj = (rawValue: string): (string | RegExp)[] => {
    const cpfMask = [
      /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/
    ];
    const cnpjMask = [
      /\w/, /\w/, '.',    // 2 dígitos/letras e ponto
      /\w/, /\w/, /\w/, '.', // 3 dígitos/letras e ponto
      /\w/, /\w/, /\w/, '/', // 3 dígitos/letras e barra
      /\w/, /\w/, /\w/, /\w/, '-', // 4 dígitos/letras e traço
      /\d/, /\d/          // 2 dígitos
    ];

    const cleanInput = rawValue.replace(/[^\w]/gi, '');
    const isCnpj = /[a-zA-Z]/.test(cleanInput) || cleanInput.length > 11;

    return isCnpj ? cnpjMask : cpfMask;
  };
}
